<template>
  <div class="card" v-if="showIndexDetail">
    <h5 class="card-header bg-primary text-white">Risk Index Finding Summary</h5>
    <div class="card-body p-0">
      <div class="container-fluid">
        <div class="row m-3">
          <p>Your organization has not yet set up Investigations. To set up Investigations for your organization, please contact us.</p>
          <p>
            Our Investigative Automated Online Interview enables you to gather higher quality leads to close cases faster with higher confidence and less
            disruption to business.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  data() {
    return {
      selectedCategoryCode: null,
    };
  },
  computed: {
    ...mapGetters("static", ["reportResponseEdits", "reportObservationEdits"]),
    showIndexDetail() {
      return this.report != null && this.report.statusCode === "completed";
    },
    riskIndex() {
      return this.report ? this.report.riskIndex || {} : {};
    },
  },
  watch: {
    selectedCategory() {
      if (this.categories && this.categories.length > 0 && !this.selectedCategory) this.selectedCategoryCode = this.categories[0].code;
    },
  },
  created() {
    this.selectedCategoryCode = this.$route.query.cc;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

table {
  @extend .mb-0;

  tr {
    cursor: pointer;
  }

  th,
  td {
    @extend .text-center;
    @extend .align-middle;

    h4,
    h5 {
      @extend .mb-0;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
